// @owners { team: patients-team }
import { NavBarLogo, getBrand } from '@alto/design-system';
import React from 'react';
import styled from 'styled-components';
import { getImage } from '~shared/assets/images/getImage';
import progynyLogo from '~shared/assets/images/progyny_by_alto_logo@2x.png';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { useSelectorShared } from '~shared/store';

export type Props = {
  readonly illustrationSrc?: string | null;
  readonly isPartnerLogo?: boolean;
  readonly partnershipName?: string | null;
};

const OnboardingAltoLogo = styled.img`
  width: 60px;
  height: 31px;
`;

const OnboardingFuzeHealthLogo = styled.img`
  width: 160px;
  height: 31px;
`;

const OnboardingPartnerLogo = styled.img`
  width: 102px;
  height: 56px;
`;

export const OnboardingNavBarLogo = ({ illustrationSrc, isPartnerLogo = false, partnershipName = null }: Props) => {
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);
  if (showProgyny) {
    return (
      <NavBarLogo
        height="SM"
        width="XL"
        source={progynyLogo}
        accessibilityLabel="progyny-logo"
      />
    );
  }

  if (isPartnerLogo) {
    return (
      <OnboardingPartnerLogo
        src={illustrationSrc || getImage('logo')}
        alt="partner-logo"
      />
    );
  }

  // need to check both partnershipName and brand to ensure we're using the correct logo
  if (partnershipName === 'fuze_health' || (partnershipName === 'fertility' && getBrand() === 'fuzehealth')) {
    return (
      // specific logo dimensions for fuze_health logo
      <OnboardingFuzeHealthLogo
        src={illustrationSrc || getImage('logo')}
        alt="fuze-health-logo"
      />
    );
  }

  return (
    <OnboardingAltoLogo
      src={illustrationSrc || getImage('logo')}
      alt="alto-logo"
    />
  );
};
